import React, { PureComponent } from 'react';

import { ThemeContext } from 'utils/theme';
import { sizes } from 'utils/detection';
import BannerSectionModel from 'models/BannerSection';

import Wrapper from './styled/Wrapper';
import ImgWrapper from './styled/ImgWrapper';
import Img from './styled/Img';
import TextWrapper from './styled/TextWrapper';
import Heading from './styled/Heading';
import Text from './styled/Text';

export default class BannerSection extends PureComponent {


  static contextType = ThemeContext;

  state = {
    marginLeft: 0,
  };

  componentDidMount() {
    window.addEventListener('resize', this.onResize);
    this.onResize();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    if (window.innerWidth >= sizes.medium) {
      const margin = Math.min(0.4 * window.innerWidth, 450) + 180 + 60;
      this.setState({ marginLeft: `${-margin}px` });
    }
  };

  render() {
    const { image, heading, text } = this.props;
    const { marginLeft } = this.state;

    return (
      <Wrapper theme={this.context} style={{ marginLeft }}>
        <ImgWrapper>
          <Img src={image.url} />
        </ImgWrapper>
        <TextWrapper>
          <Heading>{heading}</Heading>
          <Text>{text}</Text>
        </TextWrapper>
      </Wrapper>
    );
  }
}
